import React from 'react'
import PropTypes from 'prop-types'
import { StaticQuery, graphql } from 'gatsby'

import ContextProvider from '~/provider/ContextProvider'
import Header from '~/components/Header'
import GlobalStyle from '~/styles/global'
import '../styles/main.css'
import { Main } from './styles'

// Components
import Cart from '~/components/Cart'

const Layout = ({ children, location }) => {
  const isFloatingHeaderPage =
    location.pathname === '/' || location.pathname.includes('/about') || location.pathname.includes('/contact')
  
  const isInvertedHeaderPage = location.pathname.includes('/about') || location.pathname.includes('/contact')

  const hideOnCurrentPage = location.pathname === '/';


  return (
    <ContextProvider>
      <StaticQuery
        query={graphql`
          query SiteTitleQuery {
            site {
              siteMetadata {
                title
              }
            }
          }
        `}
        render={data => (
          <>
            <Cart />
            <Header siteTitle={data.site.siteMetadata.title} floating={isFloatingHeaderPage} inverted={isInvertedHeaderPage} hide={hideOnCurrentPage} />
            <Main>{children}</Main>
          </>
        )}
      />
      <GlobalStyle />
    </ContextProvider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
